import React from "react";
import ExternalLinks from "./ExternalLinks";
import { ALIGNMENT_CLASSES } from "../utils/constants";

const Footer: React.FC = () => {
  return (
    <footer className="bg-white mt-16">
      <div className={`${ALIGNMENT_CLASSES} py-8`}>
        <div className="flex flex-col md:flex-row justify-between items-center font-extrabold">
          {/* Logo/Brand */}
          <div className="mb-4 md:mb-0">
            <span className="f text-muted-black text-xl">
              Soundness Events <span className="font-light text-lg"> | 2025</span>
            </span>
          </div>

          {/* Social Links */}
          <div className="flex items-center">
            <ExternalLinks 
              instagram="soundness.events"
              className="text-muted-lavender hover:text-muted-darkGrey transition-colors"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 